var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"App"},[_c('a-locale-provider',{attrs:{"locale":_vm.locale}},[_c('a-spin',{attrs:{"spinning":_vm.$store.state.loading}},[_c('keep-alive',{attrs:{"exclude":"addVerificationList"}},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }